export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const setSuccessMessage = (message, className = '') => ({
  type: SET_SUCCESS_MESSAGE,
  message,
  className,
});
export const setErrorMessage = (message, className = '') => ({
  type: SET_ERROR_MESSAGE,
  message,
  className,
});

export const clearMessage = () => ({ type: CLEAR_MESSAGE });
